import React, { Component } from 'react'

import './Page.css'

import Header from '../Header'
import Content from '../Content'

class Page extends Component {

    render() {

        return (
            <div className="Page">
                <Header/>
                <Content>
                    {this.props.children}
                </Content>
            </div>
        )
    }

}

export default Page;


// WEBPACK FOOTER //
// ./src/Components/Page/index.js